import { render, staticRenderFns } from "./OrderRequestsFilter.vue?vue&type=template&id=15871513&"
import script from "./OrderRequestsFilter.vue?vue&type=script&lang=js&"
export * from "./OrderRequestsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports